import Vue from 'vue'
import Vuex from 'vuex'
import despacho from '@/store/despacho.js'
import comparador from '@/store/comparador.js'
import disponibilidad from '@/store/disponibilidad.js'
import monitor from '@/store/monitor.js'
import monitorCliente from '@/store/monitorCliente.js'
import monitorDespacho from '@/store/monitorDespacho.js'
import monitorPosteriores from '@/store/monitorPosteriores.js'
import monitorZona from '@/store/monitorZona.js'
import sesion from '@/store/sesion.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    comparador,
    despacho,
    disponibilidad,
    monitor,
    monitorCliente,
    monitorDespacho,
    monitorPosteriores,
    monitorZona,
    sesion
  }
})
